var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 7.16663C7.77931 7.16663 7.56735 7.25442 7.41107 7.4107C7.25479 7.56698 7.16699 7.77895 7.16699 7.99996V9.33329C7.16699 9.60944 6.94313 9.83329 6.66699 9.83329C6.39085 9.83329 6.16699 9.60944 6.16699 9.33329V7.99996C6.16699 7.51373 6.36015 7.04741 6.70396 6.7036C7.04778 6.35978 7.5141 6.16663 8.00033 6.16663H9.33366C9.6098 6.16663 9.83366 6.39048 9.83366 6.66663C9.83366 6.94277 9.6098 7.16663 9.33366 7.16663H8.00033Z",
    fill: "#38393D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 14.1666C6.94313 14.1666 7.16699 14.3905 7.16699 14.6666V16C7.16699 16.221 7.25479 16.4329 7.41107 16.5892C7.56735 16.7455 7.77931 16.8333 8.00033 16.8333H9.33366C9.6098 16.8333 9.83366 17.0571 9.83366 17.3333C9.83366 17.6094 9.6098 17.8333 9.33366 17.8333H8.00033C7.51409 17.8333 7.04778 17.6401 6.70396 17.2963C6.36015 16.9525 6.16699 16.4862 6.16699 16V14.6666C6.16699 14.3905 6.39085 14.1666 6.66699 14.1666Z",
    fill: "#38393D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.167 6.66663C14.167 6.39048 14.3908 6.16663 14.667 6.16663H16.0003C16.4866 6.16663 16.9529 6.35978 17.2967 6.7036C17.6405 7.04741 17.8337 7.51373 17.8337 7.99996V9.33329C17.8337 9.60944 17.6098 9.83329 17.3337 9.83329C17.0575 9.83329 16.8337 9.60944 16.8337 9.33329V7.99996C16.8337 7.77895 16.7459 7.56698 16.5896 7.4107C16.4333 7.25442 16.2213 7.16663 16.0003 7.16663H14.667C14.3908 7.16663 14.167 6.94277 14.167 6.66663Z",
    fill: "#38393D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3337 14.1666C17.6098 14.1666 17.8337 14.3905 17.8337 14.6666V16C17.8337 16.4862 17.6405 16.9525 17.2967 17.2963C16.9529 17.6401 16.4866 17.8333 16.0003 17.8333H14.667C14.3908 17.8333 14.167 17.6094 14.167 17.3333C14.167 17.0571 14.3908 16.8333 14.667 16.8333H16.0003C16.2213 16.8333 16.4333 16.7455 16.5896 16.5892C16.7459 16.4329 16.8337 16.221 16.8337 16V14.6666C16.8337 14.3905 17.0575 14.1666 17.3337 14.1666Z",
    fill: "#38393D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 10.6666C9.5 10.3905 9.72386 10.1666 10 10.1666H10.0067C10.2828 10.1666 10.5067 10.3905 10.5067 10.6666C10.5067 10.9428 10.2828 11.1666 10.0067 11.1666H10C9.72386 11.1666 9.5 10.9428 9.5 10.6666Z",
    fill: "#38393D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.6666C13.5 10.3905 13.7239 10.1666 14 10.1666H14.0067C14.2828 10.1666 14.5067 10.3905 14.5067 10.6666C14.5067 10.9428 14.2828 11.1666 14.0067 11.1666H14C13.7239 11.1666 13.5 10.9428 13.5 10.6666Z",
    fill: "#38393D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98308 13.6429C10.1803 13.4496 10.4969 13.4528 10.6902 13.6501C10.8608 13.8243 11.0646 13.9627 11.2895 14.0572C11.5143 14.1517 11.7558 14.2003 11.9997 14.2003C12.2436 14.2003 12.485 14.1517 12.7099 14.0572C12.9348 13.9627 13.1385 13.8243 13.3092 13.6501C13.5025 13.4528 13.819 13.4496 14.0163 13.6429C14.2135 13.8361 14.2167 14.1527 14.0235 14.3499C13.7597 14.6192 13.4448 14.8331 13.0973 14.9791C12.7498 15.1251 12.3766 15.2003 11.9997 15.2003C11.6227 15.2003 11.2496 15.1251 10.9021 14.9791C10.5546 14.8331 10.2397 14.6192 9.97587 14.3499C9.78261 14.1527 9.78584 13.8361 9.98308 13.6429Z",
    fill: "#38393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.495ca26e789ee36189cef81f56c7fa93.svg";
export { ForwardRef as ReactComponent };